<button fd-button [fdType]="'transparent'" id="reset-main-filters" title="Clear Filter"
        [disabled]="disableClearFilter" (click)="onReset()">
    <app-icon icon="filter-circle-xmark" size="lg" [fixedWidth]="true"></app-icon>
</button>
